import React from "react";
import ZHLang from '../../i18n/locales/zh-CN.json';
import DELang from '../../i18n/locales/de-DE.json';
import ENLang from '../../i18n/locales/en-GB.json';

export const LanguageContext = React.createContext(null);

export const getLanguageStr = (lang) => {
    switch (lang) {
        case "de":
            return "DE";
        case "zh":
            return "中文";
        case "en":
        default:
            return "EN";
    }
}

export const getLocale = (localeStr) => {
    switch (localeStr) {
        case "de":
            return "de-DE";
        case "zh":
            return "zh-CN";
        case "en":
        default:
            return "en-GB";
    }
}

export const getLangFile = (lang) => {
    switch (lang) {
        case "de":
            return DELang;
        case "zh":
            return ZHLang;
        case "en":
        default:
            return ENLang;
    }
}